import { KomuJsonSchema } from "types";
import cryptoJS from "crypto-js";
import md5 from "md5";

const encryptField = (data: object, key: string, encryptionType: string) => {
  const encryptionKey = "komu_";

  data[key] = data[key].trim();

  if (encryptionType === "md5") data[key] = md5(encryptionKey + data[key]);
  else if (encryptionType === "aes") data[key] = cryptoJS.AES.encrypt(data[key], encryptionKey).toString();
};

export const encryptFieldsIfNeeded = (data: object, dataSchemaAttributes) => {
  Object.entries(dataSchemaAttributes).forEach((entry: [string, KomuJsonSchema]) => {
    const [key, value] = entry;

    if (value.type === "object") encryptFieldsIfNeeded(data[key], value.properties);
    else if (value.encrypt && data[key]) encryptField(data, key, value.encrypt.type);
  });

  return data;
};
